// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"223990fc","81":"6be4a314","200":"f86bea2b","483":"9f166000","539":"a84e9879","787":"cda612ba"}[chunkId] + ".chunk.js";
};